// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1xq0F","choiceBoxes":"toolbarselects_choiceBoxes__aGORs","simpleField":"toolbarselects_simpleField__8z9yI"};